import { Entry } from "contentful";
import { ContentBlock, Metadata } from "../models";
import { getURLToContentfulEntry } from "./getURLToContentfulEntry";

export const storeContentfulDebuggingInfo = (entry: Entry<ContentBlock & Metadata>) => {
    const storage = window.localStorage;
    let contentfulUrls: Record<string, string> = {};
    try{
      const strUrls = storage.getItem('trailhead_contentful_urls') || '';
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      contentfulUrls = JSON.parse(JSON.parse(strUrls) as string);
    }catch(e){}
    try{
      contentfulUrls[entry?.fields.id] = getURLToContentfulEntry(entry);
      storage.setItem('trailhead_contentful_urls', JSON.stringify(contentfulUrls));
    }catch(e){}
};
